import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { Checkbox, Flex, Input, Select, Typography, TimePicker } from "antd"
import React, { useState, useMemo } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  addAbonement,
  editAbonement,
  getAbonementTypes,
} from "src/store/Slices/AbonementsSlice"
import { getAbonementsList } from "src/store/Slices/AbonementsSlice"
import { openNotification } from "src/components/helpers/notification"
import dayjs from "dayjs"

const EditNewAbonement = ({ visible, setVisible, abonementInfo }) => {
  // HELPERS
  const dispatch = useDispatch()

  const abonemetsTypes = useSelector(
    (state) => state.AbonementsSlice.abonemetsTypes,
  )

  // STATE
  const [name, setName] = useState(abonementInfo?.name)
  const [code, setCode] = useState(abonementInfo?.code)
  const [type, setType] = useState(
    abonemetsTypes?.data?.value?.find(
      (el) => el?.label === abonementInfo?.typeName,
    )?.value,
  )
  const [isBuyable, setIsBuyable] = useState(false)
  const [isPremium, setIsPremium] = useState(false)
  const isBuyOptions = [
    { value: true, label: "Да" },
    { value: false, label: "Нет" },
  ]

  useEffect(() => {
    setName(abonementInfo?.name)
    setCode(abonementInfo?.code)
    if (abonementInfo?.isBuyable === "Да") {
      setIsBuyable(true)
    }
    if (abonementInfo?.isPremium === "Да") {
      setIsPremium(true)
    }

    setType(
      abonemetsTypes?.data?.value?.find(
        (el) => el?.label === abonementInfo?.typeName,
      )?.value,
    )
  }, [abonemetsTypes, abonementInfo])

  useEffect(() => {
    dispatch(getAbonementTypes())
  }, [])

  const onClickAddAbonement = () => {
    dispatch(
      editAbonement({
        id: abonementInfo.id,
        name: name,
        code: code,
        typeId: type,
        isBuyable: isBuyable,
        isPremium: isPremium,
      }),
    ).then(() => {
      dispatch(getAbonementsList())
      setVisible(false)
    })
  }

  return (
    <CModal
      alignment='center'
      visible={visible}
      aria-labelledby='VerticallyCenteredExample'
      onClose={() => {
        setVisible(false)
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id='VerticallyCenteredExample'>
          {"Редактировать абонемент"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>Наименование</Typography.Title>
              <Input
                defaultValue=''
                value={name}
                onChange={(e) => setName(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Код изображения</Typography.Title>
              <Input
                defaultValue=''
                value={code}
                onChange={(e) => setCode(e.currentTarget.value)}
              />
            </div>

            <div>
              <Typography.Title level={5}>Тип</Typography.Title>
              <Select
                style={{ width: "100%" }}
                options={abonemetsTypes?.data?.value}
                onChange={(value) => {
                  setType(value)
                }}
                placeholder={"Выбрать"}
                value={type}
              />
            </div>
            <div>
              <Typography.Title level={5}>Доступен</Typography.Title>
              <Select
                style={{ width: "100%" }}
                value={isBuyable}
                onChange={(e) => setIsBuyable(e)}
                options={isBuyOptions}
              />
            </div>
            <div style={{ display: "flex", gap: "5px" }}>
              <Typography.Title level={5}>Premium абонемент</Typography.Title>
              <Checkbox
                style={{ marginTop: "-5px" }}
                checked={isPremium}
                onChange={(e) => setIsPremium(e.target.checked)}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setVisible(false)
          }}
          style={{ color: "#fff" }}
          color='secondary'
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddAbonement} style={{ color: "#fff" }}>
          Редактировать
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default EditNewAbonement
